/* tslint:disable */

// ====================================================
// START: Typescript template
// ====================================================

// ====================================================
// Scalars
// ====================================================

/** A type representing a formatted java.util.UUID */
export type Uuid = any;

/** A type representing a Locale such as en_US or fr_FR */
export type Locale = any;

/** A type representing a full protocol, host and path */
export type Url = any;

// ====================================================
// InputTypes
// ====================================================

/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: HttpHeaderInput[];
  /** Remote address of HTTP Request */
  remoteAddress: string;
  /** URL of HTTP Request */
  url: string;
}

export interface HttpHeaderInput {
  name: string;

  values: string[];
}
/** The input BEX context used for identifying users, sites and other platform functions */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: ClientInfoInput | null;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: string | null;
  /** Debugging context, such as Abacus overrides */
  debugContext?: DebugContextInput | null;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: number | null;
  /** Client/user information */
  identity: IdentityInput;
  /** The context locale, e.g. "en_US" */
  locale: Locale;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: number;
}
/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: string;
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: string | null;
}
/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: ExposureInput[];
  /** ALTER mode */
  alterMode?: AlterMode | null;
}
/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: number;
  /** The numeric Abacus ID for an experiment */
  id: string;
}
/** Device information */
export interface DeviceInput {
  type: DeviceType;
}
/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: AuthenticationState | null;
  /** The device ID (DUAID) */
  duaid: Uuid;
  /** The Expedia User ID */
  expUserId?: string | null;
  /** The user TUID */
  tuid?: string | null;
}

export interface AirportSearchCriteriaInput {
  airportCities?: string[] | null;

  airportCityStates?: string[] | null;

  airportCodes?: string[] | null;

  airportNames?: string[] | null;

  metroCodes?: string[] | null;

  pagination?: PaginationInput | null;

  sort?: AirportSortOption | null;
}
/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: number | null;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: number | null;
}

export interface PhoneCountriesSearchCriteriaInput {
  countryCodes?: string[] | null;

  prefixNumbers?: string[] | null;
}

export interface ActivityDateRangeInput {
  endDate: DateInput;

  startDate: DateInput;
}
/** A common date object */
export interface DateInput {
  /* * The raw date with time ISO format, e.g. `2019-12-16T08:00:00Z`*/
  raw?: string;
  /* * The ISO format, e.g. `2019-12-16`*/
  isoFormat?: string;
  /** The day of the month, e.g. `1` for the 1st */
  day: number;
  /** The numeric month, e.g. `1` for January */
  month: number;
  /** The four-digit year e.g. `1999` */
  year: number;
}
/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: CoordinatesInput | null;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: string | null;
  /** Gaia region ID of the search */
  regionId?: string | null;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: number;
  /** The longitude of the point in degrees */
  longitude: number;
}
/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** field which identifies sem channel */
  sem?: string | null;
  /** field which identifies semdtl value */
  semdtl?: string | null;
}
/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: number;

  height: number;

  width: number;
}

export interface ActivityOfferFilterInput {
  selections?: ActivitySelectedValueInput[] | null;

  tickets?: ActivityTicketInput[] | null;
}

export interface ActivitySelectedValueInput {
  id: string;

  value: string;
}

export interface ActivityTicketInput {
  code: string;

  count: number;
}
/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by activity category, supported with legacy categories */
  categories?: ActivityCategory[] | null;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: string[] | null;
  /** Filter results by user provided free text search keyword */
  keyword?: string | null;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: string | null;

  selections?: ActivitySelectedValueInput[] | null;
}
/** Activity search region information */
export interface ActivityRegionInput {
  /** Full name of the region, used for exact resolution */
  fullRegionName?: string | null;
  /** Gaia region ID of the search */
  regionId: string;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;

  checkOutDate: DateInput;
}
/** Property search destination information */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: CoordinatesInput | null;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: string | null;
  /** List of property IDs to return search information for. */
  propertyIds?: string[] | null;
  /** The Gaia region ID of the search */
  regionId?: string | null;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: string | null;
}
/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: PropertyFilterAccessibility[] | null;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: PropertyFilterAmenity[] | null;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomCount?: number[] | null;
  /** Filter results by Deals */
  deals?: DealType[] | null;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: string | null;
  /** Filter results by the payment type. */
  paymentType?: PaymentType[] | null;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: string | null;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: PriceRangeInput | null;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: number[] | null;
  /** Filter results by user provided string */
  propertyName?: string | null;
  /** Property syle filters */
  propertyStyles?: PropertyStyle[] | null;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: ReviewScoreRangeInput | null;
  /** Filter results by availability */
  showAvailableOnly?: boolean | null;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: number[] | null;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: StarRangeInput | null;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: StructureType[] | null;
  /** An SEM theme that needs to be passed through to other services */
  theme?: string | null;
  /** Filter results by the type of traveler. */
  travelerType?: TravelerType[] | null;
  /** Filter results by VIP only properties */
  vipOnly?: boolean | null;
}
/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: number | null;
  /** The minimum price, e.g. 50.00 */
  min?: number | null;
}
/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: number | null;
  /** The minimum review score, e.g. 1.0 */
  min?: number | null;
}

export interface StarRangeInput {
  max?: number | null;

  min?: number | null;
}
/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: string | null;
  /** Meta afflid channel code */
  afflid?: string | null;
  /** Meta afmcid channel code */
  afmcid?: string | null;
  /** Meta brandcid channel code */
  brandcid?: string | null;
  /** Meta emlcid channel code */
  emlcid?: string | null;
  /** Meta emldtl channel code */
  emldtl?: string | null;
  /** Meta gclid channel code */
  gclid?: string | null;
  /** Meta icmcid channel code */
  icmcid?: string | null;
  /** Meta icmdtl channel code */
  icmdtl?: string | null;
  /** Meta k_user_id channel code */
  k_user_id?: string | null;
  /** Meta kword channel code */
  kword?: string | null;
  /** Meta lnkloc channel code */
  lnkloc?: string | null;
  /** A consolidated list of marketing channels in key/value pairs.Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}] */
  marketingChannels?: PropertyMarketingTagInput[] | null;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: number | null;
  /** Meta mdpcid channel code */
  mdpcid?: string | null;
  /** Meta mdpdtl channel code */
  mdpdtl?: string | null;
  /** Meta olacid channel code */
  olacid?: string | null;
  /** Meta oladtl channel code */
  oladtl?: string | null;
  /** Meta semcid channel code */
  semcid?: string | null;
  /** Meta semdtl channel code */
  semdtl?: string | null;
  /** Meta seocid channel code */
  seocid?: string | null;
}
/** An object with simple key/value combination for a marketing channel.Example: {"key": "mctc", "value": "3"} */
export interface PropertyMarketingTagInput {
  key: string;

  value: string;
}
/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: number;
  /** The number of children in the room */
  children?: ChildInput[] | null;
}
/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: number;
}
/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: string[] | null;
  /** Maps to ReviewScoreRange */
  guestRating?: string | null;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: string[] | null;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: number[] | null;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** Maps to PropertySort */
  sort?: string | null;
  /** Maps to starList */
  stars?: string | null;
  /** Maps to StructureType */
  structureTypes?: string[] | null;
}
/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: InterestInput[] | null;
  /** SEM param, fetch from URL */
  semDtl?: string | null;
  /** SEM param, fetch from URL */
  semdtl?: string | null;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: string | null;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: string | null;
}
/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: string | null;
  /** Name of interest */
  name?: string | null;
}
/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: MultiItemContextInput | null;
}
/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: string;
  /** The package type for this search */
  packageType: PackageType;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;

  checkOut: DateInput;

  id: string;

  inventoryType: InventoryType;

  noCreditCard?: boolean | null;

  ratePlanId: string;

  roomTypeId: string;

  rooms: PropertyRoomInput[];

  shoppingPath?: ShoppingPathType | null;
}
/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: number[];

  numberOfAdults: number;
}
/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: PropertyReviewCategory | null;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: boolean | null;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: boolean | null;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Locale | null;
  /** Filter review results by a list of review ratings */
  ratings?: number[] | null;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: PropertyReviewType | null;
  /** Filter review results by room type */
  roomTypeId?: number | null;
  /** Filter review results by user provided keyword */
  searchTerm?: string | null;
  /** Filter review results by travel companions */
  travelCompanion?: string[] | null;
  /** Filter review results by trip reasons */
  tripReason?: string[] | null;
}
/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}
/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: string;

  passengers: PassengerBreakdownInput;

  productTokens: string[];
}
/** Indicates the kind of passengers (number and type) to search a flight for */
export interface PassengerBreakdownInput {
  childAges: number[];

  infantInSeat: boolean;

  numberOfAdults: number;

  numberOfSeniors: number;
}
/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: string | null;
  /** Gaia region id of the location */
  regionId?: string | null;
}
/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Trip type in search */
  tripType: FlightsTripType;
}
/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Departure departureDate of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: string;
  /** Cabin class preference #DEPRECATION WARNING: Please Use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: FlightsCabinClass | null;
  /** Three letter code of the origin airport */
  origin: string;
}
/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply addd this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter */
  arrivalAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the value associated with departure airport filter */
  departureAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: FlightsDurationBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: FlightsStopBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: FlightsPreferredAirlineFilterValueInput | null;
}
/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: string;
}
/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}
/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: number;
}
/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}
/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: number;

  stopFilterOperation: FlightsStopFilterOperation;
}
/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: string;
}
/** Preferences for flights search */
export interface FlightsSearchPreferencesInput {
  /** Represents advanced filters like non-stop, refundable */
  advancedFilters?: FlightsAdvancedFilterType[] | null;
  /** Airline preference */
  airline?: string | null;
  /** Cabin class preference */
  cabinClass: FlightsCabinClass;
}
/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;

  sortType: FlightsSortType;
}
/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: number[] | null;
  /** Traveler count */
  count: number;
  /** Traveler type */
  travelerType: FlightsTravelerType;
}
/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: string | null;
}

export interface FiltersInput {
  dates?: DateValueInput[] | null;

  numbers?: NumberValueInput[] | null;

  ranges?: RangeValueInput[] | null;

  selections?: SelectedValueInput[] | null;
}

export interface DateValueInput {
  id: string;

  value: DateInput;
}

export interface NumberValueInput {
  id: string;

  value: number;
}

export interface RangeValueInput {
  id: string;

  max: number;

  min: number;
}

export interface SelectedValueInput {
  id: string;

  value: string;
}
/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: number;
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: string | null;
}

export interface CartFlightSearchContextInput {
  /** The age of every children at the time of the flight */
  childAges: number[];
  /** Flight filters */
  filter?: CartFlightFilterInput | null;
  /** The list of infant(s) sitting on laps */
  infantsInLap: boolean[];
  /** The number of adults */
  numberOfAdults: number;
  /** List of origins and destinations flight components */
  originDestinations: CartOriginDestinationSearchInput[];
  /** The type of ticket searched */
  searchType: CartFlightSearchType;
}

export interface CartFlightFilterInput {
  /** non-stop flights only filter */
  nonStopOnly?: boolean | null;
  /** Preferred airline filter */
  preferredAirline?: string | null;
  /** Preferred class filter */
  preferredClass?: string | null;
  /** refundable flights only filter */
  refundableOnly?: boolean | null;
}

export interface CartOriginDestinationSearchInput {
  /** The departure date of the flight */
  departure: DateInput;
  /** The code (TLA) of the arrival airport */
  destinationAirportCode: string;
  /** The code (TLA) of the departure airport */
  originAirportCode: string;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  naturalKeys: PropertyNaturalKeyInput[];

  offerIndex: number;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: string;
  /** The list of rooms that user searched for */
  rooms: PropertyRoomInput[];
}
/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}
/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: string;

  productToken: string;
}
/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: string;

  specialEquipments?: SpecialEquipment[] | null;
}
/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;

  value: string;
}
/** Describes a Property related Conversation */
export interface LodgingConversationMetadataInput {
  checkIn: DateInput;

  checkOut: DateInput;

  createdAt: Url;

  from: MessageFromInput;

  propertyId: string;

  rooms: PropertyRoomInput[];
}

export interface MessageFromInput {
  emailAddress: string;

  name: string;
}

export interface BookingInput {
  cars?: BookingCarInput[] | null;
  /** Email required for booking information to be sent to */
  email: string;
  /** List of ways to pay for the booking. */
  paymentMethods: PaymentMethodInput[];

  properties?: BookingPropertyInput[] | null;
  /** Total price of the booking */
  totalPrice?: MoneyInput | null;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: string;
}
/** Name of the main traveler */
export interface PersonNameInput {
  firstName: string;

  lastName: string;
}
/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: string;

  prefixNumber: string;
}
/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Credit card token that allows payment from a stored credit card */
  creditCardToken: string;
}
/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;

  preferences?: PropertyPreferencesInput | null;
  /** The unique identifier of the product sometimes referred to as componentId / entityId. Used to identify a product in the TripService. */
  reference: string;
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: boolean | null;
}
/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: number[] | null;
  /** The user's requested bed type */
  bedType?: string | null;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: boolean | null;
  /** Free text special request to be conveyed to the property */
  specialRequests?: string | null;
}
/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: string;

  value: string;
}

/** History of user's searches */
export interface HistoryProductInfo {
  regionId: string;
  propertyId: string;
}

// ====================================================
// Enums
// ====================================================

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  DEBUG = "DEBUG",
  NONE = "NONE",
  PREVIEW = "PREVIEW",
  RELEASED = "RELEASED"
}
/** Valid device types */
export enum DeviceType {
  APP_PHONE = "APP_PHONE",
  APP_TABLET = "APP_TABLET",
  CHAT_APP = "CHAT_APP",
  DESKTOP = "DESKTOP",
  MOBILE_PHONE = "MOBILE_PHONE",
  MOBILE_TABLET = "MOBILE_TABLET",
  VOICE_APP = "VOICE_APP"
}

export enum AuthenticationState {
  ANONYMOUS = "ANONYMOUS",
  AUTHENTICATED = "AUTHENTICATED",
  IDENTIFIED = "IDENTIFIED"
}
/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = "CAN_NOT_TRACK",
  CAN_TRACK = "CAN_TRACK"
}
/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = "LTR",
  RTL = "RTL"
}

export enum AirlineSortingCriteria {
  CODE = "CODE",
  NAME = "NAME"
}

export enum AirlineActiveState {
  ACTIVE = "ACTIVE",
  BOTH = "BOTH",
  INACTIVE = "INACTIVE"
}

export enum AirportSortOption {
  CITY = "CITY",
  CODE = "CODE",
  NAME = "NAME"
}
/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = "CATEGORY",
  FILTER_NESTED_CATEGORIES = "FILTER_NESTED_CATEGORIES",
  GUEST_PROMO = "GUEST_PROMO",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS"
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER"
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = "ADULTS_ONLY_SHOWS",
  ADVENTURES = "ADVENTURES",
  ADVENTURE_OUTDOOR = "ADVENTURE_OUTDOOR",
  AIRBOAT_TOURS = "AIRBOAT_TOURS",
  AIRPLANE_RIDES = "AIRPLANE_RIDES",
  AIRPLANE_TOURS = "AIRPLANE_TOURS",
  AIRPORT_GROUND_TRANSPORTATION = "AIRPORT_GROUND_TRANSPORTATION",
  AIRPORT_LOUNGES = "AIRPORT_LOUNGES",
  AIRPORT_TO_AIRPORT_TRANSFERS = "AIRPORT_TO_AIRPORT_TRANSFERS",
  AIR_BALLOON_HELICOPTER_TOURS = "AIR_BALLOON_HELICOPTER_TOURS",
  AIR_HELICOPTER_BALLOON_TOURS = "AIR_HELICOPTER_BALLOON_TOURS",
  AMUSEMENT_THEME_PARKS = "AMUSEMENT_THEME_PARKS",
  ARCHITECTURE_TOURS = "ARCHITECTURE_TOURS",
  ART_CLASSES = "ART_CLASSES",
  ART_CULTURE_HISTORY_TOURS = "ART_CULTURE_HISTORY_TOURS",
  ART_MUSIC_LITERARYTOURS = "ART_MUSIC_LITERARYTOURS",
  ATTRACTIONS = "ATTRACTIONS",
  ATTRACTION_TICKETS = "ATTRACTION_TICKETS",
  BALLOON_RIDES = "BALLOON_RIDES",
  BALLOON_TOURS = "BALLOON_TOURS",
  BAR_PUB_TOURS = "BAR_PUB_TOURS",
  BEER_BREWERY_TOURS = "BEER_BREWERY_TOURS",
  BEYOND_THE_CITY = "BEYOND_THE_CITY",
  BIKE_MOUNTAIN_BIKE_TOURS = "BIKE_MOUNTAIN_BIKE_TOURS",
  BIKE_RENTALS = "BIKE_RENTALS",
  BOAT_RENTAL = "BOAT_RENTAL",
  BOAT_TOURS = "BOAT_TOURS",
  BOAT_TOURS_CRUISES = "BOAT_TOURS_CRUISES",
  BRUNCHC_RUISES = "BRUNCHC_RUISES",
  BUNGEE_JUMPING_SKYDIVING = "BUNGEE_JUMPING_SKYDIVING",
  BUS_MINIVAN_TOURS = "BUS_MINIVAN_TOURS",
  CABARET = "CABARET",
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  CASTLE_PALACE_TOURS = "CASTLE_PALACE_TOURS",
  CHAUFFER_SERVICES = "CHAUFFER_SERVICES",
  CHRISTMAS = "CHRISTMAS",
  CIRQUE = "CIRQUE",
  CIRQUE_DU_SOLEIL = "CIRQUE_DU_SOLEIL",
  CIRQUE_DU_SOLEILSHOWS = "CIRQUE_DU_SOLEILSHOWS",
  CITY_AND_ATTRACTION_TRANSFERS = "CITY_AND_ATTRACTION_TRANSFERS",
  CITY_ATTRACTION_TRANSFERS = "CITY_ATTRACTION_TRANSFERS",
  CITY_TOURS = "CITY_TOURS",
  CITY_TOURS_PACKAGES = "CITY_TOURS_PACKAGES",
  CLASSES_WORKSHOPS = "CLASSES_WORKSHOPS",
  CLUB_AND_PARTY_BUS_TOURS = "CLUB_AND_PARTY_BUS_TOURS",
  CLUB_PARTY_BUS_TOURS = "CLUB_PARTY_BUS_TOURS",
  COFFEE_TEA_TOURS = "COFFEE_TEA_TOURS",
  COMEDY_SHOWS = "COMEDY_SHOWS",
  CONCERTS_SPECIAL_EVENTS = "CONCERTS_SPECIAL_EVENTS",
  COOKING_CLASSES = "COOKING_CLASSES",
  CRUISES_BOAT_TOURS = "CRUISES_BOAT_TOURS",
  CRUISES_WATER_TOURS = "CRUISES_WATER_TOURS",
  CULTURAL_HERITAGE_EXPERIENCES = "CULTURAL_HERITAGE_EXPERIENCES",
  CUSTOM_PRIVATE_TOURS = "CUSTOM_PRIVATE_TOURS",
  DANCE_CLASSES = "DANCE_CLASSES",
  DAY_OF_THE_DEAD = "DAY_OF_THE_DEAD",
  DAY_SPAS = "DAY_SPAS",
  DAY_TRIPS = "DAY_TRIPS",
  DAY_TRIPS_EXCURSIONS = "DAY_TRIPS_EXCURSIONS",
  DINING_EXPERIENCES = "DINING_EXPERIENCES",
  DINNER_CRUISES = "DINNER_CRUISES",
  DINNER_THEATER = "DINNER_THEATER",
  DISNEY = "DISNEY",
  DISNEY_PARKS = "DISNEY_PARKS",
  DOLPHIN_WHALE_WATCHING = "DOLPHIN_WHALE_WATCHING",
  DOSE_OF_CULTURE = "DOSE_OF_CULTURE",
  DUCK_TOURS = "DUCK_TOURS",
  EASTER = "EASTER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FASHION_SHOWS_TOURS = "FASHION_SHOWS_TOURS",
  FISHING_CHARTERS_TOURS = "FISHING_CHARTERS_TOURS",
  FISHING_TOURS_AND_CHARTERS = "FISHING_TOURS_AND_CHARTERS",
  FOOD_DRINK = "FOOD_DRINK",
  FOOD_DRINK_NIGHTLIFE = "FOOD_DRINK_NIGHTLIFE",
  FOOD_TOURS = "FOOD_TOURS",
  FUN_FOR_FOODIES = "FUN_FOR_FOODIES",
  FUN_ON_THE_WATER = "FUN_ON_THE_WATER",
  GALLERIES_MUSEUMS = "GALLERIES_MUSEUMS",
  GAMES_SHOWS_SPECIAL_EVENTS = "GAMES_SHOWS_SPECIAL_EVENTS",
  GETTING_AROUND = "GETTING_AROUND",
  GOLF_TEE_TIMES = "GOLF_TEE_TIMES",
  GOLF_TOURS_TEE_TIMES = "GOLF_TOURS_TEE_TIMES",
  HALLOWEEN = "HALLOWEEN",
  HAMMAMS_TURKISH_BATHS = "HAMMAMS_TURKISH_BATHS",
  HELICOPTER_RIDES = "HELICOPTER_RIDES",
  HELICOPTER_TOURS = "HELICOPTER_TOURS",
  HIGH_SPEED_DRIVING = "HIGH_SPEED_DRIVING",
  HIGH_SPEED_RIDES = "HIGH_SPEED_RIDES",
  HIKING_CAMPING = "HIKING_CAMPING",
  HISTORICAL_TOURS = "HISTORICAL_TOURS",
  HISTORY_CULTURE = "HISTORY_CULTURE",
  HOLIDAY_SEASONAL_TOURS = "HOLIDAY_SEASONAL_TOURS",
  HONEYMOON_PACKAGE = "HONEYMOON_PACKAGE",
  HONEYMOON_PACKAGES = "HONEYMOON_PACKAGES",
  HOP_ON_HOP_OFF = "HOP_ON_HOP_OFF",
  HOP_ON_HOP_OFF_TOURS = "HOP_ON_HOP_OFF_TOURS",
  HORSE_CARRIAGE_RIDES = "HORSE_CARRIAGE_RIDES",
  HOT_SPRINGS_THERMAL_SPAS = "HOT_SPRINGS_THERMAL_SPAS",
  INTERESTS = "INTERESTS",
  KAYAKING_CANOEING = "KAYAKING_CANOEING",
  LATEST_GREATEST = "LATEST_GREATEST",
  LIFT_TICKETS = "LIFT_TICKETS",
  LIKELY_TO_SELL_OUT = "LIKELY_TO_SELL_OUT",
  LITERARY_ART_MUSIC_TOURS = "LITERARY_ART_MUSIC_TOURS",
  LOCAL_EXPERT_PICKS = "LOCAL_EXPERT_PICKS",
  LUNCH_CRUISES = "LUNCH_CRUISES",
  MOTORCYCLE_SCOOTER_TOURS = "MOTORCYCLE_SCOOTER_TOURS",
  MOVIE_TV_TOURS = "MOVIE_TV_TOURS",
  MULTIDAY_CRUISES = "MULTIDAY_CRUISES",
  MULTI_DAY_EXTENDED_TOURS = "MULTI_DAY_EXTENDED_TOURS",
  MUSEUM_TICKETS = "MUSEUM_TICKETS",
  MUSEUM_TICKETS_PASSES = "MUSEUM_TICKETS_PASSES",
  MUST_SEE_SIGHTS = "MUST_SEE_SIGHTS",
  NA = "NA",
  NATIONAL_HOLIDAYS = "NATIONAL_HOLIDAYS",
  NEW = "NEW",
  NEWY_EARS = "NEWY_EARS",
  NIGHTLIFE = "NIGHTLIFE",
  NIGHTLIFE_PASSES = "NIGHTLIFE_PASSES",
  NIGHT_CRUISES = "NIGHT_CRUISES",
  NIGHT_TOURS = "NIGHT_TOURS",
  ONSENS = "ONSENS",
  OTHER_ANIMALS_ACTIVITIES = "OTHER_ANIMALS_ACTIVITIES",
  OTHER_ANIMAL_ACTIVITIES = "OTHER_ANIMAL_ACTIVITIES",
  OTHER_CLASSES = "OTHER_CLASSES",
  OTHER_OUTDOOR_ACTIVITIES = "OTHER_OUTDOOR_ACTIVITIES",
  OTHER_SEASONAL_EVENTS = "OTHER_SEASONAL_EVENTS",
  OTHER_TOURS = "OTHER_TOURS",
  OTHER_TRANSFERS = "OTHER_TRANSFERS",
  OTHER_TRANSPORTATION = "OTHER_TRANSPORTATION",
  OTHER_WATER_ACTIVITIES = "OTHER_WATER_ACTIVITIES",
  PHOTOGRAPHY_TOURS = "PHOTOGRAPHY_TOURS",
  PORT_TRANSFERS = "PORT_TRANSFERS",
  PRIVATE_CUSTOM_TOURS = "PRIVATE_CUSTOM_TOURS",
  PRIVATE_DAY_TRIPS = "PRIVATE_DAY_TRIPS",
  PRIVATE_TOURS = "PRIVATE_TOURS",
  PRIVATE_TRANSFERS = "PRIVATE_TRANSFERS",
  PURE_ROMANCE = "PURE_ROMANCE",
  RELIGIOUS_SPIRITUAL_TOURS = "RELIGIOUS_SPIRITUAL_TOURS",
  RIVER_HARBOUR_CRUISES = "RIVER_HARBOUR_CRUISES",
  ROMAN_STAYCATION = "ROMAN_STAYCATION",
  SAFARIS = "SAFARIS",
  SAILING_TRIPS = "SAILING_TRIPS",
  SCOOTER_RENTALS = "SCOOTER_RENTALS",
  SEGWAY_TOURS = "SEGWAY_TOURS",
  SHARED_TRANSFERS = "SHARED_TRANSFERS",
  SHARK_DIVING = "SHARK_DIVING",
  SHOPPING_FASHION = "SHOPPING_FASHION",
  SHOPPING_PASSES_OFFERS = "SHOPPING_PASSES_OFFERS",
  SHOPPING_TOURS = "SHOPPING_TOURS",
  SHORE_EXCURIONS = "SHORE_EXCURIONS",
  SHOWS_CONCERTS = "SHOWS_CONCERTS",
  SHOW_SPORT_TICKETS = "SHOW_SPORT_TICKETS",
  SIGHTSEEING_ATTRACTION_PASSES = "SIGHTSEEING_ATTRACTION_PASSES",
  SIGHTSEEING_CITY_PASSES = "SIGHTSEEING_CITY_PASSES",
  SIGHTSEEING_PASSES = "SIGHTSEEING_PASSES",
  SKIING_RENTALS = "SKIING_RENTALS",
  SKIP_THE_LINE_TOURS = "SKIP_THE_LINE_TOURS",
  SNORKELING_SCUBA_DIVING = "SNORKELING_SCUBA_DIVING",
  SNOWBOARDING_RENTALS = "SNOWBOARDING_RENTALS",
  SNOWMOBILE_TOURS = "SNOWMOBILE_TOURS",
  SNOWSHOEING = "SNOWSHOEING",
  SPA = "SPA",
  SPA_WELLNESS = "SPA_WELLNESS",
  SPEED_BOATS_JET_SKIS = "SPEED_BOATS_JET_SKIS",
  SPORTING_EVENTS_PACKAGES = "SPORTING_EVENTS_PACKAGES",
  SPORTS_PACKAGES = "SPORTS_PACKAGES",
  STAY_ACTIVE = "STAY_ACTIVE",
  SUBMARINE_TOURS = "SUBMARINE_TOURS",
  SUNSET_CRUISES = "SUNSET_CRUISES",
  SUPERNATURAL_TOURS = "SUPERNATURAL_TOURS",
  SUSTAINABLE_TOURS = "SUSTAINABLE_TOURS",
  SWIM_WITH_DOLPHINS = "SWIM_WITH_DOLPHINS",
  THEATER_SHOWS_MUSICALS = "THEATER_SHOWS_MUSICALS",
  THEME_PARKS = "THEME_PARKS",
  THEME_PARK_TICKETS_TOURS = "THEME_PARK_TICKETS_TOURS",
  THE_GREAT_OUTDOORS = "THE_GREAT_OUTDOORS",
  THRILL_SEEKER = "THRILL_SEEKER",
  TICKETS = "TICKETS",
  TOURS_ACTIVITIES = "TOURS_ACTIVITIES",
  TOURS_SIGHTSEEING = "TOURS_SIGHTSEEING",
  TRANSPORTATION_SERVICES = "TRANSPORTATION_SERVICES",
  TREAT_YOURSELF = "TREAT_YOURSELF",
  TUBING = "TUBING",
  UNIVERSAL_THEME_PARKS = "UNIVERSAL_THEME_PARKS",
  VALENTINES_DAY = "VALENTINES_DAY",
  WALKING_BIKE_TOURS = "WALKING_BIKE_TOURS",
  WALKING_TOURS = "WALKING_TOURS",
  WATERSKIING_WAKEBOARDING = "WATERSKIING_WAKEBOARDING",
  WATER_ACTIVITIES = "WATER_ACTIVITIES",
  WATER_PARKS = "WATER_PARKS",
  WEDDING_CEREMONIES = "WEDDING_CEREMONIES",
  WEDDING_HONEYMOON = "WEDDING_HONEYMOON",
  WEDDING_PACKAGES = "WEDDING_PACKAGES",
  WEDDING_SHONEYMOONS = "WEDDING_SHONEYMOONS",
  WHAT_TO_DO_WITH_GROUPS = "WHAT_TO_DO_WITH_GROUPS",
  WHAT_TO_DO_WITH_KIDS = "WHAT_TO_DO_WITH_KIDS",
  WHITE_WATER_RAFTING = "WHITE_WATER_RAFTING",
  WILDLIFE_NATURE = "WILDLIFE_NATURE",
  WINE_TASTING_WINERY_TOURS = "WINE_TASTING_WINERY_TOURS",
  WINTER_ACTIVITIES = "WINTER_ACTIVITIES",
  YOGA_CLASS = "YOGA_CLASS",
  YOGA_CLASSES = "YOGA_CLASSES",
  ZOO_TICKETS = "ZOO_TICKETS",
  ZOO_TICKETS_PASSES = "ZOO_TICKETS_PASSES"
}

export enum ChronoUnit {
  CENTURIES = "CENTURIES",
  DAYS = "DAYS",
  DECADES = "DECADES",
  ERAS = "ERAS",
  FOREVER = "FOREVER",
  HALFDAYS = "HALFDAYS",
  HOURS = "HOURS",
  MICROS = "MICROS",
  MILLENNIA = "MILLENNIA",
  MILLIS = "MILLIS",
  MINUTES = "MINUTES",
  MONTHS = "MONTHS",
  NANOS = "NANOS",
  SECONDS = "SECONDS",
  WEEKS = "WEEKS",
  YEARS = "YEARS"
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CANCELLATION = "NO_CANCELLATION"
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = "AIR_ATTACH_MIP",
  AIR_HOTEL_ATTACH_MIP = "AIR_HOTEL_ATTACH_MIP",
  CAMPAIGN_DEAL = "CAMPAIGN_DEAL",
  GUEST = "GUEST",
  HOTEL_ATTACH_MIP = "HOTEL_ATTACH_MIP",
  MOD = "MOD",
  STRIKE_OUT = "STRIKE_OUT"
}

export enum ActivityRedemptionType {
  PRINT = "PRINT",
  VOUCHER_LESS = "VOUCHER_LESS"
}
/** Activity Price types */
export enum ActivityPriceType {
  GROUP = "GROUP",
  NORMAL = "NORMAL",
  VOLUME_BASED = "VOLUME_BASED"
}

export enum ActivityOfferUdsToken {
  SELECTED = "SELECTED",
  UNSELECTED = "UNSELECTED"
}
/** Activity banner type */
export enum ActivityBannerType {
  ALERT = "ALERT",
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS"
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = "ADDON",
  LOGIN = "LOGIN",
  SUMMER_CAMPAIGN_PRIMARY = "SUMMER_CAMPAIGN_PRIMARY",
  SUMMER_CAMPAIGN_SECONDARY = "SUMMER_CAMPAIGN_SECONDARY"
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST"
}
/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = "CAMPAIGN_DEALS",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  RECOMMENDED = "RECOMMENDED"
}

export enum ActivityGroupType {
  ACTIVITY_LIST = "ACTIVITY_LIST",
  ACTIVITY_MESSAGE = "ACTIVITY_MESSAGE",
  CATEGORY = "CATEGORY",
  FILTERED_ACTIVITIES = "FILTERED_ACTIVITIES",
  INTERESTS = "INTERESTS",
  MORE_ACTIVITIES = "MORE_ACTIVITIES",
  NEIGHBOURHOOD = "NEIGHBOURHOOD",
  POI = "POI",
  SUB_CATEGORIES = "SUB_CATEGORIES",
  TOP_ACTIVITIES = "TOP_ACTIVITIES"
}

export enum ActivityMapGroupType {
  POI = "POI"
}
/** Activity Pill Theme */
export enum ActivityPillTheme {
  CATEGORY_FILTER = "CATEGORY_FILTER",
  FREE_TEXT_SEARCH = "FREE_TEXT_SEARCH",
  SEE_ALL = "SEE_ALL"
}

export enum ActivityCategoryType {
  ACTIVITIES = "ACTIVITIES",
  CATEGORIES = "CATEGORIES",
  DEALS_PROMOTIONS = "DEALS_PROMOTIONS",
  NA = "NA",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  TOURS = "TOURS",
  TRANSPORTATION = "TRANSPORTATION"
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = "MULTI_SELECT_LIST",
  SINGLE_SELECT = "SINGLE_SELECT",
  TEXT = "TEXT"
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = "ACCESSIBLE_BATHROOM",
  IN_ROOM_ACCESSIBLE = "IN_ROOM_ACCESSIBLE",
  ROLL_IN_SHOWER = "ROLL_IN_SHOWER"
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  CASINO = "CASINO",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  HOT_TUB = "HOT_TUB",
  KITCHEN_KITCHEN = "KITCHEN_KITCHEN",
  KITCHEN_KITCHENETTE = "KITCHEN_KITCHENETTE",
  OCEAN_VIEW = "OCEAN_VIEW",
  PETS = "PETS",
  POOL = "POOL",
  SPA_ON_SITE = "SPA_ON_SITE",
  WASHER_DRYER = "WASHER_DRYER",
  WATER_PARK = "WATER_PARK",
  WIFI = "WIFI"
}

export enum DealType {
  AARP = "AARP"
}

export enum PaymentType {
  FREE_CANCELLATION = "FREE_CANCELLATION",
  PAY_LATER = "PAY_LATER",
  PAY_WITHOUT_CREDITCARD = "PAY_WITHOUT_CREDITCARD"
}

export enum PropertyStyle {
  HOMES = "HOMES",
  HOTELS = "HOTELS",
  LUXURY = "LUXURY",
  OUTDOOR = "OUTDOOR",
  UNIQUE = "UNIQUE"
}

export enum StructureType {
  AGRITOURISM = "AGRITOURISM",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  APARTMENT = "APARTMENT",
  APART_HOTEL = "APART_HOTEL",
  BED_AND_BREAKFAST = "BED_AND_BREAKFAST",
  CABIN = "CABIN",
  CARAVAN_PARK = "CARAVAN_PARK",
  CASTLE = "CASTLE",
  CHALET = "CHALET",
  CONDO = "CONDO",
  CONDO_RESORT = "CONDO_RESORT",
  COTTAGE = "COTTAGE",
  COUNTRY_HOUSE = "COUNTRY_HOUSE",
  CRUISE = "CRUISE",
  ECO_HOTEL = "ECO_HOTEL",
  GUEST_HOUSE = "GUEST_HOUSE",
  HOLIDAY_PARK = "HOLIDAY_PARK",
  HOSTAL = "HOSTAL",
  HOSTEL = "HOSTEL",
  HOTEL = "HOTEL",
  HOTEL_RESORT = "HOTEL_RESORT",
  HOUSE_BOAT = "HOUSE_BOAT",
  INN = "INN",
  LODGE = "LODGE",
  LONGHOUSE = "LONGHOUSE",
  MOTEL = "MOTEL",
  OVERWATER = "OVERWATER",
  PALACE = "PALACE",
  PENSION = "PENSION",
  POUSADA_BRAZIL = "POUSADA_BRAZIL",
  POUSADA_PORTUGAL = "POUSADA_PORTUGAL",
  RANCH = "RANCH",
  RESIDENCE = "RESIDENCE",
  RIAD = "RIAD",
  RYOKAN = "RYOKAN",
  SAFARI = "SAFARI",
  SERVICED_APARTMENT = "SERVICED_APARTMENT",
  TOWNHOUSE = "TOWNHOUSE",
  TRADITIONAL_BUILDING = "TRADITIONAL_BUILDING",
  TREE_HOUSE = "TREE_HOUSE",
  UNKNOWN = "UNKNOWN",
  VACATION_HOME = "VACATION_HOME",
  VILLA = "VILLA",
  VIP = "VIP"
}

export enum TravelerType {
  BUSINESS = "BUSINESS",
  FAMILY = "FAMILY"
}
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS"
}
/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = "AARP_MEMBER_DISCOUNT",
  BEST_DEAL = "BEST_DEAL",
  DISTANCE = "DISTANCE",
  MEMBER_PRICING = "MEMBER_PRICING",
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  PROPERTY_CLASS = "PROPERTY_CLASS",
  PROPERTY_NAME = "PROPERTY_NAME",
  RECOMMENDED = "RECOMMENDED",
  REVIEW = "REVIEW",
  VACATION_RENTAL = "VACATION_RENTAL"
}
/** Enumerated Gaia geographic region types */
export enum RegionType {
  AIRPORT = "AIRPORT",
  CITY = "CITY",
  CONTINENT = "CONTINENT",
  COUNTRY = "COUNTRY",
  HIGH_LEVEL_REGION = "HIGH_LEVEL_REGION",
  METRO_STATION = "METRO_STATION",
  MULTI_CITY_VICINITY = "MULTI_CITY_VICINITY",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POINT_OF_INTEREST = "POINT_OF_INTEREST",
  PROVINCE_STATE = "PROVINCE_STATE",
  TRAIN_STATION = "TRAIN_STATION",
  UNKNOWN = "UNKNOWN"
}

export enum PropertyPaymentType {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW"
}

export enum PackageType {
  FLIGHT_CAR = "FLIGHT_CAR",
  FLIGHT_HOTEL = "FLIGHT_HOTEL",
  FLIGHT_HOTEL_CAR = "FLIGHT_HOTEL_CAR",
  HOTEL_CAR = "HOTEL_CAR"
}
/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AMOMA = "AMOMA",
  ANA = "ANA",
  CTRIP = "CTRIP",
  DESPEGAR = "DESPEGAR",
  DIRECT_AGENCY = "DIRECT_AGENCY",
  EZZEGO_1 = "EZZEGO_1",
  HOME_AWAY = "HOME_AWAY",
  HOTEL_BEDS = "HOTEL_BEDS",
  HRS = "HRS",
  JAC_TRAVEL = "JAC_TRAVEL",
  JAL = "JAL",
  JALAN = "JALAN",
  JTB = "JTB",
  JUMBOTOURS = "JUMBOTOURS",
  MERCHANT = "MERCHANT",
  MIKI = "MIKI",
  OPAQUE = "OPAQUE",
  OSTROVOK = "OSTROVOK",
  PEGASUS = "PEGASUS",
  RAKUTEN = "RAKUTEN",
  SUNHOTELS = "SUNHOTELS",
  TOURICO = "TOURICO",
  VENERE = "VENERE",
  WELCOME_BEDS = "WELCOME_BEDS",
  WOORI = "WOORI",
  WORLDSPAN = "WORLDSPAN",
  WOTIF = "WOTIF",
  YOUTRAVEL = "YOUTRAVEL"
}
/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = "ATTACH",
  PACKAGE = "PACKAGE",
  STANDALONE = "STANDALONE"
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BREAKFAST_NOT_AVAILABLE = "BREAKFAST_NOT_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCEL = "FREE_CANCEL",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FREE_WIRED_INTERNET = "FREE_WIRED_INTERNET",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  INTERNET_NOT_AVAILABLE = "INTERNET_NOT_AVAILABLE",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  NON_REFUNDABLE = "NON_REFUNDABLE",
  PARKING = "PARKING",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESERVE_NOW_PAY_DEPOSIT = "RESERVE_NOW_PAY_DEPOSIT",
  RESERVE_NOW_PAY_LATER = "RESERVE_NOW_PAY_LATER",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WATERSLIDE = "WATERSLIDE",
  WIFI_SURCHARGE = "WIFI_SURCHARGE",
  WIRED_INTERNET_SURCHARGE = "WIRED_INTERNET_SURCHARGE"
}

export enum BadgeIcon {
  ACCESS_TIME = "ACCESS_TIME",
  ADD = "ADD",
  ADDON = "ADDON",
  ADDON_WHITE_BG = "ADDON_WHITE_BG",
  ADDON_YELLOW_BG = "ADDON_YELLOW_BG",
  EXP29639_ORB = "EXP29639_ORB",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO_OUTLINE = "INFO_OUTLINE",
  MOD = "MOD",
  PLUS_CIRCLE = "PLUS_CIRCLE",
  SMARTPHONE = "SMARTPHONE"
}

export enum Theme {
  BRAND = "BRAND",
  DEAL_ADD_ON = "DEAL_ADD_ON",
  DEAL_BUNDLED = "DEAL_BUNDLED",
  DEAL_GENERIC = "DEAL_GENERIC",
  DEAL_MEMBER = "DEAL_MEMBER",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  INFO = "INFO",
  LINK = "LINK",
  NOTIFICATION = "NOTIFICATION",
  SAVED = "SAVED",
  SPONSORED = "SPONSORED",
  SUCCESS = "SUCCESS",
  SUCCESS_MEDIUM = "SUCCESS_MEDIUM",
  SUPPLIER_PROMO = "SUPPLIER_PROMO",
  URGENT = "URGENT",
  VIEWED = "VIEWED",
  VIP = "VIP"
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = "NON_REFUNDABLE",
  REFUNDABLE_WITH_NO_PENALTY = "REFUNDABLE_WITH_NO_PENALTY",
  REFUNDABLE_WITH_PENALTY = "REFUNDABLE_WITH_PENALTY"
}

export enum RateDiscountType {
  MEMBER_DEAL = "MEMBER_DEAL",
  MOBILE_EXCLUSIVE = "MOBILE_EXCLUSIVE",
  REGULAR = "REGULAR",
  TONIGHT_ONLY = "TONIGHT_ONLY"
}

export enum FeeType {
  DEFAULT = "DEFAULT",
  DEFAULT_SUPPLIER_COLLECTED = "DEFAULT_SUPPLIER_COLLECTED",
  GROUPED_MANDATORY_FEES = "GROUPED_MANDATORY_FEES",
  L26_TAX_BREAKOUT = "L26_TAX_BREAKOUT",
  NORMAL = "NORMAL",
  OTHER = "OTHER",
  PER_PERSON_PER_NIGHT = "PER_PERSON_PER_NIGHT",
  PROPERTY = "PROPERTY",
  REFUNDABLE_DAMAGE_DEPOSIT = "REFUNDABLE_DAMAGE_DEPOSIT",
  RESORT = "RESORT"
}

export enum PropertyPaymentModel {
  PAY_LATER = "PAY_LATER",
  PAY_LATER_WITH_DEPOSIT = "PAY_LATER_WITH_DEPOSIT",
  PAY_NOW = "PAY_NOW"
}

export enum StrikeOutType {
  ATTACH = "ATTACH",
  INVALID = "INVALID",
  LOYALTY = "LOYALTY",
  PACKAGE = "PACKAGE",
  PRICE_SURVEY = "PRICE_SURVEY",
  STANDALONE = "STANDALONE"
}

export enum PricingSchemeType {
  DAILY_RATE = "DAILY_RATE",
  TOTAL_RATE = "TOTAL_RATE"
}

export enum SourceType {
  ESR = "ESR",
  GDS = "GDS"
}
/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = "BUSINESS_TRAVELERS",
  COUPLES = "COUPLES",
  EVERYONE = "EVERYONE",
  FAMILIES = "FAMILIES",
  GETAWAY_WITH_FRIENDS = "GETAWAY_WITH_FRIENDS",
  GOLF = "GOLF",
  OTHER = "OTHER",
  OVERNIGHT_STAY = "OVERNIGHT_STAY",
  PERSONAL_EVENT = "PERSONAL_EVENT",
  SHOPPING = "SHOPPING",
  SPA = "SPA",
  STUDENTS = "STUDENTS"
}
/** [Optional] Review filter type */
export enum PropertyReviewType {
  CRITICAL = "CRITICAL",
  POSITIVE = "POSITIVE"
}
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = "HIGHEST_TO_LOWEST_RATED",
  LOWEST_TO_HIGHEST_RATED = "LOWEST_TO_HIGHEST_RATED",
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  NEWEST_TO_OLDEST_BY_LANGUAGE = "NEWEST_TO_OLDEST_BY_LANGUAGE",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST",
  OLDEST_TO_NEWEST_BY_LANGUAGE = "OLDEST_TO_NEWEST_BY_LANGUAGE"
}
/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = "ACCESSIBLE_ROLL_IN_SHOWER",
  AIR_CONDITIONING = "AIR_CONDITIONING",
  ALL_INCLUSIVE = "ALL_INCLUSIVE",
  ARCADE = "ARCADE",
  BABYSITTING = "BABYSITTING",
  BAR = "BAR",
  BOWLING = "BOWLING",
  BREAKFAST_AVAILABLE = "BREAKFAST_AVAILABLE",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CHILDREN_CLUB = "CHILDREN_CLUB",
  DAILY_HOUSEKEEPING = "DAILY_HOUSEKEEPING",
  EXTRA_BED = "EXTRA_BED",
  FITNESS_EQUIPMENT = "FITNESS_EQUIPMENT",
  FREE_AIRPORT_TRANSPORTATION = "FREE_AIRPORT_TRANSPORTATION",
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_PARKING = "FREE_PARKING",
  FREE_WELCOME_DRINK = "FREE_WELCOME_DRINK",
  FRONT_DESK_24_HOURS = "FRONT_DESK_24_HOURS",
  GROCERY = "GROCERY",
  HIGH_SPEED_INTERNET = "HIGH_SPEED_INTERNET",
  HOT_TUB = "HOT_TUB",
  IN_ROOM_INTERNET = "IN_ROOM_INTERNET",
  KIDS_POOL = "KIDS_POOL",
  KITCHEN = "KITCHEN",
  LAUNDRY = "LAUNDRY",
  LIVING_AREA = "LIVING_AREA",
  MICROWAVE = "MICROWAVE",
  MINI_GOLF = "MINI_GOLF",
  PARKING = "PARKING",
  PETS_ALLOWED = "PETS_ALLOWED",
  PLAYGROUND = "PLAYGROUND",
  POOL = "POOL",
  RESTAURANT_IN_HOTEL = "RESTAURANT_IN_HOTEL",
  ROOM_SERVICE = "ROOM_SERVICE",
  SMOKE_FREE = "SMOKE_FREE",
  SOUNDPROOF_ROOM = "SOUNDPROOF_ROOM",
  SPA_SERVICES_ON_SITE = "SPA_SERVICES_ON_SITE",
  SPECIAL_DEAL = "SPECIAL_DEAL",
  TENNIS_COURT = "TENNIS_COURT",
  TOYS = "TOYS",
  WATERSLIDE = "WATERSLIDE"
}

export enum PropertyAmenityType {
  ACCESSIBILITY = "ACCESSIBILITY",
  BATHROOM = "BATHROOM",
  BEDROOM = "BEDROOM",
  BUSINESS_SERVICES = "BUSINESS_SERVICES",
  CONVENIENCES = "CONVENIENCES",
  ENTERTAINMENT = "ENTERTAINMENT",
  FAMILY_FRIENDLY = "FAMILY_FRIENDLY",
  FOOD_DRINK = "FOOD_DRINK",
  GUEST_SERVICES = "GUEST_SERVICES",
  INTERNET = "INTERNET",
  MORE = "MORE",
  OUTDOOR = "OUTDOOR",
  OUTDOOR_SPACE = "OUTDOOR_SPACE",
  PARKING = "PARKING",
  PROPERTY = "PROPERTY",
  ROOM = "ROOM",
  SPA = "SPA",
  THINGS_TO_DO = "THINGS_TO_DO"
}
/** The UDS icon used for the map marker */
export enum MapIconType {
  HOTEL = "HOTEL",
  SOLD_OUT = "SOLD_OUT"
}
/** The type of map marker */
export enum MarkerType {
  HOTEL = "HOTEL",
  POI = "POI"
}
/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = "KILOMETER",
  MILE = "MILE"
}

export enum OfferAttributeType {
  FREE_BREAKFAST = "FREE_BREAKFAST",
  FREE_CANCELLATION = "FREE_CANCELLATION",
  NO_CC_REQUIRED = "NO_CC_REQUIRED",
  PAYMENT_CHOICE = "PAYMENT_CHOICE",
  VIP = "VIP"
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = "ARTIFICIALLY_FENCED_RATE",
  MIXED_RATE_PLAN = "MIXED_RATE_PLAN",
  NO_CREDIT_CARD = "NO_CREDIT_CARD"
}
/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  AUTHWINDOW = "AUTHWINDOW",
  COPY = "COPY",
  FREE_LX = "FREE_LX",
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS"
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = "ADDON",
  COMPRESSION = "COMPRESSION",
  COUPON = "COUPON",
  DOUBLE_POINTS = "DOUBLE_POINTS",
  FREE_LX = "FREE_LX",
  LOGIN = "LOGIN",
  LOYALTY = "LOYALTY",
  OVERFILTERED = "OVERFILTERED",
  VACATION_RENTALS = "VACATION_RENTALS"
}
/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = "CAP",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  NA = "NA"
}

export enum TemporaryFlightTripType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP"
}
/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = "APRIL",
  AUGUST = "AUGUST",
  DECEMBER = "DECEMBER",
  FEBRUARY = "FEBRUARY",
  JANUARY = "JANUARY",
  JULY = "JULY",
  JUNE = "JUNE",
  MARCH = "MARCH",
  MAY = "MAY",
  NOVEMBER = "NOVEMBER",
  OCTOBER = "OCTOBER",
  SEPTEMBER = "SEPTEMBER"
}
/** Represent all the possible trip types */
export enum FlightsTripType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP"
}
/** cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = "BUSINESS",
  COACH = "COACH",
  FIRST = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY"
}
/** Enum representing the various time slots in a day */
export enum FlightsTimeOfDay {
  AFTERNOON = "AFTERNOON",
  EARLY_MORNING = "EARLY_MORNING",
  EVENING = "EVENING",
  MORNING = "MORNING"
}
/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = "EQUAL",
  GREATER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL"
}
/** Represent all the possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = "NONSTOP",
  REFUNDABLE = "REFUNDABLE"
}
/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = "DECREASING",
  INCREASING = "INCREASING"
}
/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = "ARRIVAL",
  DEPARTURE = "DEPARTURE",
  DURATION = "DURATION",
  PRICE = "PRICE",
  RECOMMENDED = "RECOMMENDED"
}
/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = "ADULT",
  CHILD = "CHILD",
  INFANT_IN_LAP = "INFANT_IN_LAP",
  INFANT_IN_SEAT = "INFANT_IN_SEAT"
}
/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  EMPHASIS = "EMPHASIS",
  IMPORTANT = "IMPORTANT",
  STANDARD = "STANDARD"
}
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY"
}
/** Available action types an actionable element */
export enum FlightsActionType {
  DISMISS = "DISMISS",
  GO_TO_DETAILS = "GO_TO_DETAILS",
  GO_TO_NEXT_JOURNEY = "GO_TO_NEXT_JOURNEY",
  GO_TO_PACKAGES = "GO_TO_PACKAGES",
  LOAD_CROSS_SELL_DIALOG = "LOAD_CROSS_SELL_DIALOG",
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = "LOAD_STANDARD_OFFER_FARE_RULE_MODULE",
  REFRESH = "REFRESH"
}
/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = "FADE",
  NONE = "NONE"
}

export enum FlightsSearchFormErrorType {
  DATE_NOT_IN_VALID_RANGE = "DATE_NOT_IN_VALID_RANGE",
  INVALID_DATE_FORMAT = "INVALID_DATE_FORMAT",
  INVALID_TRAVELER_COUNT = "INVALID_TRAVELER_COUNT",
  LESS_THAN_MINIMUM_ADULT = "LESS_THAN_MINIMUM_ADULT",
  LOCATION_EMPTY = "LOCATION_EMPTY",
  LOCATION_SAME = "LOCATION_SAME",
  PAST_DATE_NOT_ALLOWED = "PAST_DATE_NOT_ALLOWED",
  SPECIAL_CHARACTER_NOT_ALLOWED = "SPECIAL_CHARACTER_NOT_ALLOWED",
  TOO_SHORT_AIRPORT_STRING = "TOO_SHORT_AIRPORT_STRING",
  UNATTENDED_INFANT_IN_LAP = "UNATTENDED_INFANT_IN_LAP",
  UNATTENDED_INFANT_IN_SEAT = "UNATTENDED_INFANT_IN_SEAT"
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = "ARRIVAL_AIRPORT",
  ARRIVAL_TIME = "ARRIVAL_TIME",
  DEPARTURE_AIRPORT = "DEPARTURE_AIRPORT",
  DEPARTURE_TIME = "DEPARTURE_TIME",
  DURATION = "DURATION",
  NUM_OF_STOPS = "NUM_OF_STOPS",
  PREFERRED_AIRLINE = "PREFERRED_AIRLINE"
}

export enum RecommendedType {
  DESTINATIONS = "DESTINATIONS",
  OFFERS = "OFFERS"
}

export enum ProductQuestionTopic {
  HOTEL = "HOTEL"
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = "NEWEST_TO_OLDEST",
  OLDEST_TO_NEWEST = "OLDEST_TO_NEWEST"
}

export enum TripIntentPersonType {
  ADULT = "ADULT",
  CHILD = "CHILD"
}

export enum HistoryType {
  ACTIVITY_DETAIL = "ACTIVITY_DETAIL",
  ACTIVITY_SEARCH = "ACTIVITY_SEARCH",
  CAR_DETAIL = "CAR_DETAIL",
  CAR_SEARCH = "CAR_SEARCH",
  CRUISE_SEARCH = "CRUISE_SEARCH",
  FLIGHT_DETAIL = "FLIGHT_DETAIL",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  PACKAGE_SEARCH = "PACKAGE_SEARCH",
  PROPERTY_DETAIL = "PROPERTY_DETAIL",
  PROPERTY_SEARCH = "PROPERTY_SEARCH"
}
/** Gender of the customer */
export enum CustomerGender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  UNKNOWN = "UNKNOWN"
}
/** Available Flight Seating Preferences */
export enum SeatingPreferenceType {
  AISLE = "AISLE",
  NO_PREFERENCE = "NO_PREFERENCE",
  WINDOW = "WINDOW"
}
/** Status of the Invite for travel Arranger / Arrangee */
export enum InviteStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  TERMINATED = "TERMINATED"
}
/** Type of the Invite(Arranger/Arrangee) */
export enum InviteType {
  INVITE_BY_ARRANGEE = "INVITE_BY_ARRANGEE",
  INVITE_BY_ARRANGER = "INVITE_BY_ARRANGER"
}

export enum ProductType {
  ARTICLE = "ARTICLE",
  CAR_DETAILS = "CAR_DETAILS",
  DESTINATION = "DESTINATION",
  DESTINATION_EXPERIENCE = "DESTINATION_EXPERIENCE",
  EXPERIENCE = "EXPERIENCE",
  EXPERT_TIP = "EXPERT_TIP",
  FLIGHT_SEARCH = "FLIGHT_SEARCH",
  LX_DETAILS = "LX_DETAILS",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  POI_GAIA = "POI_GAIA",
  PROPERTY_DETAILS = "PROPERTY_DETAILS"
}
/** Type of visual treatment to apply.Should / will be replaced by UDS-TOKEN references. */
export enum UdsComponentType {
  MULTI_SELECT_BUTTON = "MULTI_SELECT_BUTTON",
  MULTI_SELECT_LIST = "MULTI_SELECT_LIST",
  PRIMARY_DATE = "PRIMARY_DATE",
  PRIMARY_SINGLE_SELECT = "PRIMARY_SINGLE_SELECT",
  RANGE = "RANGE",
  SINGLE_SELECT = "SINGLE_SELECT",
  TEXT = "TEXT"
}

export enum CartFlightSearchType {
  MULTI_CITY = "MULTI_CITY",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP"
}

export enum CartTtl {
  FIVE_MINUTES = "FIVE_MINUTES",
  TWELVE_HOURS = "TWELVE_HOURS"
}
/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = "ADDITIONAL_DRIVER",
  BICYCLE_RACK = "BICYCLE_RACK",
  BOOSTER_SEAT = "BOOSTER_SEAT",
  INFANT_SEAT = "INFANT_SEAT",
  LEFT_HAND_CONTROL = "LEFT_HAND_CONTROL",
  LUGGAGE_RACK = "LUGGAGE_RACK",
  NAV_SYSTEM = "NAV_SYSTEM",
  RIGHT_HAND_CONTROL = "RIGHT_HAND_CONTROL",
  ROAD_CONGESTION_PAYMENT_SCHEME = "ROAD_CONGESTION_PAYMENT_SCHEME",
  SATELLITE_RADIO = "SATELLITE_RADIO",
  SKI_RACK = "SKI_RACK",
  SNOW_CHAINS = "SNOW_CHAINS",
  SNOW_TIRES = "SNOW_TIRES",
  TODDLER_SEAT = "TODDLER_SEAT",
  TOLL_PAYMENT_TAG_PASS = "TOLL_PAYMENT_TAG_PASS",
  TRAILER_HITCH = "TRAILER_HITCH",
  WIFI_ACCESS = "WIFI_ACCESS",
  WINTER_PACKAGE = "WINTER_PACKAGE"
}
/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  SHOP_WITH_POINTS = "SHOP_WITH_POINTS"
}

export enum ConversationsOperationResult {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS"
}

export enum Result {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS"
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  DEFAULT = "DEFAULT",
  SEARCHED_DATE_HEADER = "SEARCHED_DATE_HEADER"
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = "DEFAULT"
}

export enum FlightsFlexibleSearchResultCellTheme {
  DEFAULT_PRICE = "DEFAULT_PRICE",
  LOWEST_PRICE = "LOWEST_PRICE",
  NO_PRICE = "NO_PRICE",
  SEARCHED_DATE = "SEARCHED_DATE",
  SEARCHED_DATE_LOWEST_PRICE = "SEARCHED_DATE_LOWEST_PRICE",
  SEARCHED_DATE_NO_PRICE = "SEARCHED_DATE_NO_PRICE",
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = "SEARCHED_DATE_UNAVAILABLE_FLIGHTS",
  UNAVAILABLE_FLIGHTS = "UNAVAILABLE_FLIGHTS"
}
/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  ACCESSIBILITY_INPUT = "ACCESSIBILITY_INPUT",
  BEDDING_INPUT = "BEDDING_INPUT",
  SMOKING_INPUT = "SMOKING_INPUT",
  SPECIAL_REQUEST_TEXT = "SPECIAL_REQUEST_TEXT"
}
/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  CHECKBOX = "CHECKBOX",
  SELECT = "SELECT",
  TEXTAREA = "TEXTAREA"
}
/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  EXPANDO_LINK = "EXPANDO_LINK",
  HEADING = "HEADING"
}

export enum RouteType {
  MULTI_DESTINATION = "MULTI_DESTINATION",
  ONE_WAY = "ONE_WAY",
  ROUND_TRIP = "ROUND_TRIP"
}

// ====================================================
// END: Typescript template
// ====================================================

// ====================================================
// Documents
// ====================================================

export namespace DxPropertySearchQuery {
  export type Variables = {
    context: ContextInput;
    hotelIds: string[];
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];
  };

  export type Properties = {
    __typename?: "Property";

    id: string;

    name: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    gallery?: Gallery[] | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;

    amount: number;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;
  };

  export type Gallery = {
    __typename?: "Image";

    url: Url;

    description: string;
  };
}

export namespace MapPropertySearchById {
  export type Variables = {
    context: ContextInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    propertyIds?: string[] | null;
    filters?: PropertySearchFiltersInput | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    sortAndFilter: SortAndFilter;

    properties: Properties[];
  };

  export type SortAndFilter = {
    __typename?: "SortAndFilter";

    options?: Options | null;
  };

  export type Options = {
    __typename?: "SortAndFilterViewModel";

    sortAndFilter: _SortAndFilter[];
  };

  export type _SortAndFilter = {
    __typename?: "FilterViewModel";

    name: string;

    options: _Options[];
  };

  export type _Options = {
    __typename?: "OptionViewModel";

    label?: string | null;

    value?: string | null;

    range?: Range | null;

    enumValue?: string | null;
  };

  export type Range = {
    __typename?: "FilterOptionRange";

    min?: number | null;

    max?: number | null;
  };

  export type Properties = {
    __typename?: "Property";

    name: string;

    id: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    star?: number | null;

    image?: Image | null;

    mapMarker?: MapMarker | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;

    amount: number;

    currencyInfo: CurrencyInfo;
  };

  export type CurrencyInfo = {
    symbol: string;

    code: string;

    name: string;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type MapMarker = {
    __typename?: "MapMarker";

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: "Coordinates";

    latitude: number;

    longitude: number;
  };
}

export namespace MapPropertySearchByLatLong {
  export type Variables = {
    context: ContextInput;
    rooms?: RoomInput[] | null;
    dateRange?: PropertyDateRangeInput | null;
    latitude: number;
    longitude: number;
    filters?: PropertySearchFiltersInput | null;
    size?: number | null;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];

    summary: Summary;
  };

  export type Properties = {
    __typename?: "Property";

    name: string;

    id: string;

    infositeURL: string;

    price?: Price | null;

    reviews: Reviews;

    star?: number | null;

    image?: Image | null;

    mapMarker?: MapMarker | null;
  };

  export type Price = {
    __typename?: "PropertyPrice";

    lead?: Lead | null;
  };

  export type Lead = {
    __typename?: "Money";

    formatted: string;
  };

  export type Reviews = {
    __typename?: "PropertyReviewsSummary";

    score?: number | null;

    total?: number | null;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };

  export type MapMarker = {
    __typename?: "MapMarker";

    latLong: LatLong;
  };

  export type LatLong = {
    __typename?: "Coordinates";

    latitude: number;

    longitude: number;
  };

  export type Summary = {
    __typename?: "PropertyResultsSummary";

    messages?: Messages[] | null;
  };

  export type Messages = {
    __typename?: "MessageResult";

    type?: MessageType | null;

    title?: Title | null;

    subtitle?: Subtitle | null;
  };

  export type Title = {
    __typename?: "MessagingResultTitle";

    text?: string | null;
  };

  export type Subtitle = {
    __typename?: "MessagingResultTitle";

    text?: string | null;
  };
}

export namespace QueryPropertyReviewsHeadline {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
  };

  export type Query = {
    __typename?: "Query";

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: "PropertyInfo";

    infositeUrl?: Url | null;

    summary?: Summary | null;
  };

  export type Summary = {
    __typename?: "PropertySummary";

    id: string;

    name: string;

    overview?: Overview | null;

    location?: Location | null;
  };

  export type Overview = {
    __typename?: "PropertyOverview";

    starRating?: number | null;
  };

  export type Location = {
    __typename?: "PropertyLocation";

    address?: Address | null;
  };

  export type Address = {
    __typename?: "PropertyAddress";

    city?: string | null;

    countryCode?: string | null;

    firstAddressLine?: string | null;

    secondAddressLine?: string | null;

    postalCode?: string | null;

    province?: string | null;
  };
}

export namespace PropertySearchQuery {
  export type Variables = {
    context: ContextInput;
    hotelIds: string[];
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];
  };

  export type Properties = {
    __typename?: "Property";

    id: string;

    name: string;

    gallery?: Gallery[] | null;
  };

  export type Gallery = {
    __typename?: "Image";

    url: Url;

    description: string;
  };
}

export namespace CustomerSearchHistoryQuery {
  export type Variables = {
    context: ContextInput;
    lobs?: string[];
    numberOfResults?: number;
    hotelIds?: string[];
    dateRange?: PropertyDateRangeInput;
  };

  export type Query = {
    __typename?: "Query";

    customer: Customer;
  };

  export type Customer = {
    __typename?: "Query";

    searchHistory: History[];
  };

  export type History = {
    __typename?: "History";

    type: HistoryType;

    items: HistoryItem[];
  };

  export type HistoryItem = {
    __typename?: "HistoryItem";

    id: string;

    startDate: DateInput;

    endDate: DateInput;

    originalSearchPrice?: Money;

    productInfo: HistoryProductInfo;
  };

  export type Money = {
    __typename?: "Money";

    currencyInfo: Currency;

    amount: number;

    formatted: string;
  };

  export type Currency = {
    __typename?: "Currency";

    code: string;

    name: string;

    symbol: string;
  };

  export type HistoryPropertySearch = HistoryProductInfo & {
    __typename?: "HistoryPropertySearch";

    numberOfRooms: number;

    numberOfTravelers?: number;

    regionId: string;

    roomOccupants?: RoomOccupants[];

    regionDetail?: GeographicFeature;
  };

  export type HistoryActivityDetail = HistoryProductInfo & {
    __typename?: "HistoryActivityDetail";

    discount?: number;

    duration?: string;

    freeCancellation?: boolean;

    id?: number;

    leadTicketType?: string;

    name?: string;

    referencePrice?: Money;

    regionId: string;

    regionDetail?: GeographicFeature;
  };

  export type HistoryFlightSearch = HistoryProductInfo & {
    __typename?: "HistoryFlightSearch";

    cheapestOfferPerPerson?: Money;

    destinationAirportCode?: string;

    destinationRegionName?: string;

    flightPassengers?: FlightPassengers;

    originAirportCode?: string;

    originRegionName?: string;

    regionId: string;

    routeType?: string;
  };

  export type HistoryPackageSearch = HistoryProductInfo & {
    __typename?: "HistoryPackageSearch";

    arrivalAirport?: string;

    departureAirport?: string;

    infantsInLap: Boolean;

    localizedRegionName?: string;

    nonStop: Boolean;

    numberOfInfantsInLap?: number;

    numberOfRooms?: number;

    regionId: string;

    roomOccupants?: RoomOccupants[];

    searchUrl?: string;

    regionDetail?: GeographicFeature;
  };

  export type RoomOccupants = {
    __typename?: "RoomOccupants";

    adults?: number;

    agesOfChildren: number[];

    totalOccupants?: number;
  };

  export type GeographicFeature = {
    __typename?: "GeographicFeature";

    coordinates: Coordinates;

    fullName: String;

    id: string;

    name: string;

    type: RegionType;

    destinationInsights?: DestinationInsights;
  };

  export type DestinationInsights = {
    __typename?: "DestinationInsights";

    localGetaways: InsightsDestination[];

    lodgingCost: CostPercentilesByMonth[];

    popularMonthsToVisit: Month[];
  };

  export type InsightsDestination = {
    __typename?: "InsightsDestination";

    regionId: string;

    geographicInfo: GeographicFeature;
  };

  export type CostPercentilesByMonth = {
    __typename?: "CostPercentilesByMonth";

    month: Month;

    percentiles: CostPercentiles;
  };

  export type Month = {
    __typename?: "Month";

    id: MonthId;

    name: string;

    ordinal: number;
  };

  export type CostPercentiles = {
    __typename?: "CostPercentiles";

    eightieth: Money;

    fiftieth: Money;

    ninetieth: Money;

    tenth: Money;

    twentieth: Money;
  };

  export type FlightPassengers = {
    __typename?: "FlightPassengers";

    adults?: number;

    agesOfChildren: number[];

    infantsInLap?: number;

    infantsInSeat?: number;
  };
}

export namespace CustomerPropertySearchByIdQuery {
  export type Variables = {
    context: ContextInput;
    hotelIds: string[];
    dateRange: PropertyDateRangeInput;
  };

  export type Query = {
    __typename?: "Query";

    propertySearch: PropertySearch;
  };

  export type PropertySearch = {
    __typename?: "PropertySearchResults";

    properties: Properties[];

    searchCriteria: SearchCriteria;
  };

  export type Properties = {
    __typename?: "Property";

    id: string;

    name: string;

    thumborImage?: Image;

    infositeURL: string;

    price: PropertyPrice;
  };

  export type PropertyPrice = {
    __typename?: "PropertyPrice";

    options: PropertyPriceOption[];
  };

  export type PropertyPriceOption = {
    __typename?: "PropertyPriceOption";

    displayPrice?: Money;
  };

  export type Money = {
    __typename?: "Money";

    formatted: string;

    amount: number;

    currencyInfo?: CurrencyInfo;
  };

  export type CurrencyInfo = {
    symbol: string;

    code: string;

    name: string;
  };

  export type SearchCriteria = {
    __typename?: "SearchCriteria";

    dateRange: PropertyDateRangeInput;
  };

  export type Image = {
    __typename?: "Image";

    url: Url;
  };
}

export namespace QueryPropertyHeroImage {
  export type Variables = {
    context: ContextInput;
    propertyId: string;
  };

  export type Query = {
    __typename?: "Query";

    propertyInfo: PropertyInfo;
  };

  export type PropertyInfo = {
    __typename?: "PropertyInfo";

    gallery?: Gallery | null;
  };

  export type Gallery = {
    __typename?: "PropertyGallery";

    featured?: Featured | null;
  };

  export type Featured = {
    __typename?: "Image";

    description: string;

    url: Url;
  };
}
